var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"small-font",attrs:{"headers":_vm.headers,"height":_vm.data.tableHeight,"items":_vm.pages,"item-key":"problemPageId","footer-props":{
    'items-per-page-options': _vm.data.itemsPerPageOptions,
    'show-current-page': true,
    'show-first-last-page': true,
  },"options":_vm.tableOptions,"server-items-length":_vm.data.totalItems,"fixed-header":"","dense":"","hide-default-footer":_vm.data.loading,"loading":_vm.data.changingPage,"show-expand":"","expanded":_vm.data.expanded},on:{"update:options":[function($event){_vm.tableOptions=$event},function($event){return _vm.fetchData()}],"update:expanded":function($event){return _vm.$set(_vm.data, "expanded", $event)}},scopedSlots:_vm._u([{key:"header.data-table-expand",fn:function(ref){
  var on = ref.on;
return [_c('div',_vm._g({staticClass:"d-flex"},on),[_c('v-icon',{on:{"click":function($event){return _vm.closeAll()}}},[_vm._v(" mdi-chevron-up ")]),_c('v-icon',{on:{"click":function($event){return _vm.expandAll()}}},[_vm._v(" mdi-chevron-down ")])],1)]}},{key:"header.url",fn:function(ref){
  var header = ref.header;
return [_c('SearchableHeader',{staticClass:"mb-0",attrs:{"searchInput":_vm.data.urlSearchString,"label":header.text,"canSort":true,"isSortActive":_vm.tableOptions.sortBy[0] === 'url',"isSortDescending":_vm.tableOptions.sortDesc[0]},on:{"update":_vm.urlSearch,"sort":_vm.urlSort}})]}},{key:"item.severity",fn:function(ref){
  var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getPercentage(item.severity))+" ")]}},{key:"item.url",fn:function(ref){
  var item = ref.item;
return [_c('UrlLink',{attrs:{"to":{
        name: 'checkList-page-keywords',
        params: {
          domain: _vm.domain,
          propertyId: _vm.propertyId,
          pageId: item.problemPageId,
          pageUrl: _vm.toHex(item.problemPageUrl),
        },
      },"url":item.problemPageUrl,"maxLength":130}})]}},{key:"item.keywords",fn:function(ref){
      var item = ref.item;
return _vm._l((item.mainKeywords),function(k,i){return _c('span',{key:k.keywordId,staticClass:"pl-1"},[_c('router-link',{attrs:{"to":{
          name: 'checkList-keyword-pages',
          params: {
            domain: _vm.domain,
            propertyId: _vm.propertyId,
            keywordId: k.keywordId,
            query: k.query,
          },
        }}},[_vm._v(" "+_vm._s(_vm.getKeywordDisplayText(k))+" ")]),(i !== item.mainKeywords.length - 1)?_c('span',{staticClass:"pl-1"},[_vm._v(" | ")]):_vm._e()],1)})}},{key:"expanded-item",fn:function(ref){
        var headers = ref.headers;
        var item = ref.item;
return [_c('td',{attrs:{"colspan":headers.length}},[_c('v-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('v-data-table',{staticClass:"small-font",attrs:{"headers":_vm.targetPageHeaders,"items":item.targetPages,"item-key":"pageId","footer-props":{
            'items-per-page-options': _vm.data.itemsPerTargetOptions,
            'show-current-page': true,
            'show-first-last-page': true,
          },"fixed-header":"","dense":""},scopedSlots:_vm._u([{key:"item.severity",fn:function(ref){
          var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getPercentage(item.severity))+" ")]}},{key:"item.url",fn:function(ref){
          var item = ref.item;
return [_c('UrlLink',{attrs:{"to":{
                name: 'checkList-page-keywords',
                params: {
                  domain: _vm.domain,
                  propertyId: _vm.propertyId,
                  pageId: item.pageId,
                  pageUrl: _vm.toHex(item.url),
                },
              },"url":item.url,"maxLength":130}})]}},{key:"item.keywords",fn:function(ref){
              var item = ref.item;
return _vm._l((item.keywords),function(k,i){return _c('span',{key:k.keywordId,staticClass:"pl-1"},[_c('router-link',{attrs:{"to":{
                  name: 'checkList-keyword-pages',
                  params: {
                    domain: _vm.domain,
                    propertyId: _vm.propertyId,
                    keywordId: k.keywordId,
                    query: k.query,
                  },
                }}},[_vm._v(" "+_vm._s(_vm.getKeywordDisplayText(k))+" ")]),(i !== item.keywords.length - 1)?_c('span',{staticClass:"pl-1"},[_vm._v(" | ")]):_vm._e()],1)})}}],null,true)})],1)],1)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }